import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { dataModelPageConfig } from "./dataModelPageConfig";
import { dataModelValidators } from "./dataModelValidators";
import { DataModelTypeLabel } from "./DataModelTypeLabel";

export const dataModelRecordDefinition: RecordDefinition = {
  path: "/data-model",
  entityName: "dwdatamodel",
  listRoute: "/data-models",
  backTitle: "Back to data models",
  allowedRoles: administratorRoles,
  config: dataModelPageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Data Model",
    newRecordTitle: "New Data Model",
  },
  fieldValidators: dataModelValidators,
  // Registered here for the data models list's Type column.
  fieldComponents: { dataModelType: DataModelTypeLabel },
};
